;(function($, lotame){

    var rnn = window.rnn;
    var log = rnn.logging.log;
    var adIDs = [];
    var adRequestsSent = 0;
    var totalDefineString = "";
    var totalFastlaneDefineString = "";
    var theData = (typeof(pageData) == 'undefined')? {}: pageData;
    var siteCode = cleanUp(theData.site);
    var sector = cleanUp(theData.sector);
    var subsector = cleanUp(theData.subsector);
    var pageType = cleanUp(theData.pageType);
    var tags = cleanUp(theData.tags);
    var source = cleanUp(theData.source);
    var region = cleanUp(theData.region);
    var keyword = slugify(theData.keyword);
    var category = cleanUp(theData.category);
    var preCheckURL = clearEmail($.trim(theData.url));
    var url = cleanUp(preCheckURL);
    var siteMode = cleanUp(theData.site_mode);
    var isCarouselAd0IntervalPaused = false;
    var theInterval = null;
    var rotateIDs = [];
    var dfpNetworkID = 1054219;
    var isIE = IECheck();
    var fastlaneUniqueId = 0;

    adsReturned = 0;

    function buildDefineString(spaceID, spacePos, spaceSizes, doesItRotate, outOfPage, fastlane, fastlanePos){
        // every single ad call will have its own little define string done up.
        // once the string is generated with the right properties, we append it to the
        // total define string. this total define string is then injected into the head
        // at the end.

        var sizes = spaceSizes;
        var uniqueId = spaceID;
        var pos = spacePos;
        var refresh = doesItRotate;
        var theDefineString;
        var fastlaneDefineString;
        var sizesString = "";
        var rotateSlot = "";
        var rotateArraySlot = "";

        for(var i=0; i < sizes.length; i++){
            sizesString += i === sizes.length - 1 ? "[" + sizes[i] + "]" : "[" + sizes[i] + "], ";
        }

        // if there are an array of sizes given, this formats it correctly.
        if(sizes.length > 1){
            sizesString = "[" + sizesString + "]";
        }

        if(refresh){
            rotateArraySlot = "rotatingSlot_" + spaceID;
            rotateSlot = "rotatingSlot_" + spaceID + " = ";
            rotateIDs.push(rotateArraySlot);
        }

        if (fastlane == "true") {
            if (!fastlanePos)
                fastlanePos = 'btf';
            fastlaneDefineString = "rubicontag.defineSlot('/" + dfpNetworkID + "/" + siteCode + "." + sector + subsector + "', " + sizesString + ", '" + uniqueId + "').setPosition('" + fastlanePos + "').setFPI('pos', " + pos + ");";
        }

        if (outOfPage === "true") {
            theDefineString = "googletag.defineOutOfPageSlot('/" + dfpNetworkID + "/" + siteCode + "." + sector + subsector + "', '" + uniqueId + "').addService(googletag.pubads());";
        } else if (fastlane == "true") {
            theDefineString = "gptadslots[" + fastlaneUniqueId + "] = googletag.defineSlot('/" + dfpNetworkID + "/" + siteCode + "." + sector + subsector + "', " + sizesString + ", '" + uniqueId + "').addService(googletag.pubads()).setTargeting('pos', '" + pos + "'); ";
            fastlaneUniqueId ++;
        } else {
            theDefineString = rotateSlot + "googletag.defineSlot('/" + dfpNetworkID + "/" + siteCode + "." + sector + subsector + "', " + sizesString + ", '" + uniqueId + "').addService(googletag.pubads()).setTargeting('pos', '" + pos + "'); ";
        }

        if (fastlaneDefineString)
            totalFastlaneDefineString += fastlaneDefineString;

        adRequestsSent++;
        totalDefineString += theDefineString;
    }

    function clearEmail(url){
        // We need to clear keywords out of DFP calls.

        if(url.indexOf('keywords') > 0){
            var keywordString = url.split(' ?keywords=')[1];
            var cleanKeywords = decodeURIComponent(keywordString).toLowerCase();
            var seperatorReplaced = cleanKeywords.replace(/[+]/g, ' ');

            // kill email
            cleanKeywords = seperatorReplaced.replace(/[a-z0-9!#$%&'*+=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g, '');

            // clear extra spaces.
            cleanKeywords = cleanKeywords.replace(/\s{1,}/g, '');

            if(cleanKeywords.length === 0){
                return url.split(' ?keywords=')[0];
            } else {
                keywordString = encodeURIComponent(cleanKeywords);
                return url.split('?keywords=')[0] + 'keywords=' + keywordString;
            }
        } else {
            return url;
        }
    }

    function cleanUp(value){
        // we want to remove the following characters:
        // " ' = ! + # ; ^ ( ) < > [ ]

        var cleanString;

        if(value){
            cleanString = value.replace(/[#"'=!+;^()<>\[\]]/g,'').replace(/, /g, ',');
            cleanString = cleanString.substring(0, 80);
        } else {
            cleanString = "";
        }

        return cleanString;
    }

    function slugify(value){
        /*
            since we don't slugify keywords at template level anymore, we need to do it in the JS.
            fortunately, we don't comma seperate out keywords, so all we need to do is hyphen at each
            space and lower case everything. slugify it in JS with some regex.
        */

        var slugString;

        if(value){
            slugString = value.toLowerCase();
            slugString = slugString.replace(/[^a-zA-Z0-9]+/g,'-');

            // if first or last value of string now starts with a hyphen, remove them. there's no clean way
            // to do this, so need to substring it.
            var beginIndex = 0;

            if(slugString.charAt(0) === '-'){
                slugString = slugString.substr(0, beginIndex) + slugString.substr(beginIndex + 1);
            }

            var endIndex = slugString.length - 1;

            if(slugString.charAt(slugString.length - 1) === '-'){
                slugString = slugString.substr(0, endIndex) + slugString.substr(endIndex + 1);
            }
        } else {
            slugString = '';
        }

        return slugString;
     }

    function populateEmptyElement(elID){
        // populate the DOM element on the page with the necessary display call. this script actually
        // renders the ad once it has been called.
        var containerContent = $("<script type='text/javascript'>googletag.cmd.push(function() { googletag.display('" + elID + "'); });<\/script>");

        // execute
        $("#" + elID).append(containerContent);
    }

    function hideEmptyAdSpaces(){
        // By the nature of how our templating of ads works, there could be some extra adSpaces left over
        // that the template generates, but for this case no adSpaces are defined. We want to hide
        // these extra spaces so that they don't show.

        var adSpaceClass = 'adSpace';
        var adSpaceEmptyClass = 'adSpaceEmpty';
        var adGroupClass = 'adGroup';
        var adGroupEmptyClass = 'adGroupEmpty';
        var adGroupLabelClass = 'adGroupLabel';
        var rgx = '/default\\.gif/mig';
        var pattern = eval(rgx);

        $('.' + adSpaceClass).each(function () {
            if ($(this).html().length === 0 || ($(this).html().search(pattern) > 0)) {
                $(this).addClass(adSpaceEmptyClass).hide();
            }
        });

        $('.' + adGroupClass + ':visible').each(function () {
            if ($(this).find('.' + adSpaceClass).hasClass('.' + adSpaceEmptyClass)) {
                $(this).addClass(adGroupEmptyClass).hide();
            }
        });

        // some of our ad spaces have parent elements defined in the templates. This is a result
        // of always expecting an ad to be returned in the old ad server.
        // as a result, these parent divs will need to be individually hidden
        // current list of elements:

        // Hide Billboard ad if it is there is no billboard ad for for both 970px and 1000px
        if($('#billboardAd970').is(':hidden') && $('#billboardAd1000').is(':hidden')) {
            $('div.wrapper > div.container > div > div').find('[data-overlay-marker*="Billboard ad"], .articleBillboard').hide();
            $('div.wrapper > div.container > div > div').find('[data-overlay-marker*="Billboard ad"], .genericBillboard').hide();
        }

        // #carouselAd0
        if($('#carouselAd0').is(':hidden')){
            $('#carouselAd0').parent().hide();
        }

        // #mobileAd0
        if($('#mobileAd0').is(':visible')){
            $('footer').addClass('margin-bottom-70');
        }
    }

    function populateAds(){
        // What we need to do now is loop through every element in the DOM with class adSpace.
        // If the element ID matches with one of the uniqueIDs we have defined, fill that adspace
        // with the correct string.

        $(".adSpace").each(function() {
            var $this = $(this);
            var currentAdSpaceID = $this.attr('id');

            for(var i = 0; i < adIDs.length; i++){
                if(currentAdSpaceID === adIDs[i]){
                    // build the display string in this div.
                    populateEmptyElement(currentAdSpaceID);
                }
            }
        });

        if (rotateIDs.length > 0) {
            theInterval = setInterval(function(){
                if(!isCarouselAd0IntervalPaused){
                    if (typeof rotatingSlot_carouselAd0 !== 'undefined') {
                        refreshPartners();
                    }
                }
            }, 5000);
        }

        log('[dfp advertising] adSpaces populated');
    }

    function checkAdsReturned(){
        if(adsReturned === adRequestsSent){
            log('[dfp advertising] all ads returned. ' + adsReturned + ' total');
            $('.spinner').remove(); // hide the spinners
            hideEmptyAdSpaces();
        }
    }

    function genMidString(){
        for(var i = 0; i < rotateIDs.length; i++){
            midRotateString += rotateIDs[i];
            if(i !== rotateIDs.length - 1){
                midRotateString += ", ";
            }
        }
    }

    function generateSubscribedString(){
        var cookieUser = rnn.modules.user.cookieData();
        var string;

        if(cookieUser){
            if (cookieUser.is_staff === true) {
                string = 'staff';
            } else if (cookieUser.subscribed === true) {
                string = 'subscribed';
            } else {
                string = 'account';
            }
        } else {
            string = 'anonymous';
        }

        return string;
    }

    function appendToHeader(){
        // initialDFP sets up the DFP code. need it to call googletag.

        var audienceIDs = lotame.genLotameAudiences();
        var thirdPartyIDs = lotame.genLotameAudiences('thirdParty');
        var stagingString = 'staging.apnarm';
        var customerId = theData.customerId || '';

        if (window.location.href.indexOf(stagingString) > -1) {
            url = stagingString + ' ' + url;
        }

        document.writeln("<script type='text/javascript'>" +
"if (rubiconAccountID != '') {" +
    "rubicontag.cmd.push(function() {" +
        totalFastlaneDefineString +
        "rubicontag.run(gptrun);" +
    "});" +
"}" +
"if (!crtg_content) { var crtg_content=''; }" +
"googletag.cmd.push(function() {" +
    totalDefineString +
    "if (rubiconAccountID != '') {" +
        "$.each(gptadslots, function(key, value) {" +
            "rubicontag && rubicontag.setTargetingForGPTSlot && rubicontag.setTargetingForGPTSlot(value);" +
        "});" +
    "}" +
    "googletag.pubads().setTargeting ('page-type','" + pageType + "');" +
    "googletag.pubads().setTargeting ('tag','" + tags + "');" +
    "googletag.pubads().setTargeting ('source','" + source + "');" +
    "googletag.pubads().setTargeting ('region','" + region + "');" +
    "googletag.pubads().setTargeting ('keyword','" + keyword + "');" +
    "googletag.pubads().setTargeting ('category','" + category + "');" +
    "googletag.pubads().setTargeting ('user-type','" + generateSubscribedString() + "');" +
    "googletag.pubads().setTargeting ('section','" + sector + subsector + "');" +
    "if ('" + customerId + "') {" +
    "googletag.pubads().setTargeting('customer-id', '" + customerId + "');" +
    "}" +
    "var crtg_split = (crtg_content || '').split(';');" +
    "for (var i = 1; i < crtg_split.length; i++) {" +
        "googletag.pubads().setTargeting((crtg_split[i-1].split('='))[0], (crtg_split[i-1].split('='))[1]);" +
    "}" +
    "googletag.pubads().setTargeting ('url','" + url + "');" +
    "googletag.pubads().setTargeting ('audiences','" + audienceIDs + "');" +
    "googletag.pubads().setTargeting ('tpaud','" + thirdPartyIDs + "');" +
    "googletag.pubads().addEventListener('slotRenderEnded', function(event) {" +
        "adsReturned++; rnn.modules.dfp_advertising.check();" +
    "});" +
    "googletag.pubads().enableSingleRequest();" +
    "googletag.pubads().collapseEmptyDivs();" +
    "googletag.pubads().addEventListener('slotRenderEnded', function(event) {" +
        "var slotId = event.slot.getSlotElementId();" +
        "if (!event.isEmpty && matherMarketId && matherCustomerId && slotId !== 'carouselAd0') {" +
            "var _snaq = (window._snaq = window._snaq || []);" +
            "_snaq.push(['setCollectorUrl', 'www.i.matheranalytics.com']);" +
            "_snaq.push(['setAppId', 'v1']);" +
            "_snaq.push(['setCustomerId', matherCustomerId]);" +
            "_snaq.push(['setMarket', matherMarketId]);" +
            "_snaq.push(['trackUnstructEvent', 'Ad Impression', { eaid: event.lineItemId, ebuy: null, eadv: null, ecid: event.creativeId, eenv: 'j', epid: event.slot.getAdUnitPath().split('/')[1] || '', esid: null }]);" +
        "}" +
    "});" +
    "googletag.enableServices();" +
"});" +
"<\/script>");

        populateAds();
    }

    var dfp_ad = {
        define: function (definedAds) {
            // need to prepend m. to siteCode if it's mobile.
            if (siteMode === "mobile") {
                siteCode = "m." + siteCode;
            }

            // if there is a subsector, we need to add the definition here as it may vary.
            if (subsector) {
                subsector = "." + subsector;
            }
          
            /*
            * Essentially how this works is that all the ads are defined in json in a fragment.
            * This JSON calls to define new ads, looping through every object(ad) to get values from it:
            *           -> Available sizes
            *           -> uniqueID
            *           -> position
            */
            var isDesktopViewport = $(window).width() >= 768;
            var isMobileViewport = !isDesktopViewport;
            var defaultShowAd = true; // Default to showing every ad
            var isStandardArticle = false;
            var isStandardArticleMobile = false;
            var isSubscriber = rnn.modules.user.isSubscriber();
            
            // Check if on a standard article template and that we are not disabling the subscriber layout      
            if (document.body.classList.contains('standardArticle') && (typeof disable_subscriber_layout !== 'undefined' && disable_subscriber_layout !== 'yes')) {
                isStandardArticle = true;
            }
            
            if (isStandardArticle && isSubscriber) {
                defaultShowAd = false; // Set to hide all ads for subscribers on standard articles by default (desktop and mobile)
            }
            
            // #mobileAd1 - remove if hard coded data rules in inline recurring
            if ($('#mobileAd1').length > 0) {
                $('#mobileAd1').attr("data-rules","standard-article-subscriber-show");
            }
            
            $.each(definedAds, function() {
                $.each(this, function(title, definedSpaces) {
                    for (var i = 0; i < definedSpaces.length; i++) {
                        var showAd = defaultShowAd;
                        var currentAdSpace = definedSpaces[i];
                        var $adEl = $('#' + currentAdSpace.divID);

                        // We want certain ads to show/hide based on a data-rules="mobile-only", "desktop-only", or "standard-article-non-subscriber-only" (+ others are coming)
                        if ($adEl.data('rules')) {
                            var rules = $adEl.data('rules'); 
                            var isSubscriberOnly = rules.indexOf('standard-article-subscriber-only') != -1;
                            var isSubscriberShow = rules.indexOf('standard-article-subscriber-show') != -1;
                            
                            if (rules.indexOf('mobile-only') != -1 && !isMobileViewport) {
                                showAd = false;
                            } else if (rules.indexOf('desktop-only') != -1 && !isDesktopViewport) {
                                showAd = false;
                            }
                            
                            if (isStandardArticle && !isSubscriber && isSubscriberOnly) {
                                showAd = false;
                            }
                            if (isStandardArticle && isSubscriber && (isSubscriberOnly || isSubscriberShow)) {
                                showAd = true;
                            }
                        }
                  
                        if ($adEl.length) {
                            // We want to avoid ads to be called if we are not rendering them (we used to do that in css but we need to not call dfp at all)
                            if (showAd) {
                               addToAdIdAndBuild(currentAdSpace, $adEl);
                            }
                        }
                    }
                });
            });
            appendToHeader();
        }
    };

    function addToAdIdAndBuild(currentAdSpace, $adEl) {

        adIDs.push(currentAdSpace.divID);

        // add a size specific class to adspaces
        if (currentAdSpace.sizes) {
            var size = currentAdSpace.sizes;
            if (size.length > 1) {
                size = size[0];
            }
            size = size[0];

            if (typeof size === 'string') {
                $adEl.addClass('width' + size.split(',')[0]);
            }
        }
        // build the string based on current ID, pos and sizes
        buildDefineString(currentAdSpace.divID, currentAdSpace.pos, currentAdSpace.sizes, currentAdSpace.rotate, currentAdSpace.outOfPage, currentAdSpace.fastlane, currentAdSpace.fastlanePos);
    }

    function refreshPartners(){
        window.clearInterval(theInterval);

        if (typeof rotatingSlot_carouselAd0 !== 'undefined') {
            if (isIE) {
                var id = 'carouselAd0';
                $("#"+id).html('');
                googletag.pubads().refresh([rotatingSlot_carouselAd0]);
                populateEmptyElement(id);

                theInterval = setInterval(function(){
                    if(!isCarouselAd0IntervalPaused){
                        if (typeof rotatingSlot_carouselAd0 !== 'undefined') {
                            var $el = $('#carouselAd0');
                            if(window.rnn.modules.utilities.isElementInViewport($el)){
                                refreshPartners();
                            }
                        }
                    }
                }, 5000);
            } else {
                googletag.cmd.push(function() {
                    refreshCarouselAd();
                });

                theInterval = setInterval(function(){
                    if(!isCarouselAd0IntervalPaused){
                        var $el = $('#carouselAd0');

                        if(window.rnn.modules.utilities.isElementInViewport($el)){
                            refreshCarouselAd();
                        }
                    }
                }, 5000);
            }
        }
    }

    function refreshCarouselAd(){
      googletag.pubads().refresh([rotatingSlot_carouselAd0]);
    }

    function IECheck() {
        var isIE = false;

        if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
            isIE = true;
        }

        return isIE;
    }

    function loadSpinners(){
        // we want to put some spinners in a couple of the adspaces before they load.
        var spinnerURL = rnn.site.mediaURL + 'rnn/base/img/miscSize/ajaxSpinner.gif';
        var img = '<img class="spinner" src="' + spinnerURL + '" />';
        $('#adSpace1').html(img);
        $('#carouselAd0').html(img);
    }

    function makeStickyMrecsDynamic() {
        var $targetElems = $('.rnn_ri_container_mrec-1, .rnn_ri_container_mrec-2, .rnn_ri_container_mrec-3').toArray();

        $targetElems.forEach(function(elem) {
            var elemHeight = $(elem).height();
            var parentElemHeight = $(elem).closest('.span4').siblings('.span8').height();

            if(elemHeight < parentElemHeight) {
                $(elem).parent().addClass('sticky-top-container-dynamic');
                $(elem).children().addClass('sticky-top');
            }
        });
    }

    function waitForReady(readyType) {
        var ready = {
            article: $('.plista_widget_underArticle_blockList').length === 1,
            index: $('.spinner').length === 0
        };

        if (ready[readyType]) {
            makeStickyMrecsDynamic();
        } else {
            setTimeout(waitForReady, 1500, readyType);
        }
    }

    function initDFPAds() {
        // dfp ads init'd
        loadSpinners();

        $('.rnn_ri_container_town-partners .carouselControls.prev').hide();
        $('.rnn_ri_container_local-faces .itemCarousel.adCarousel .carouselControls.prev').hide();

        $('.rnn_ri_container_town-partners .carouselControls.next, #carouselAd0').hover(
            function() {
                isCarouselAd0IntervalPaused = true;
            }, function() {
                isCarouselAd0IntervalPaused = false;
            }
        );

        $('.rnn_ri_container_town-partners .carouselControls.next').click(function() {
            refreshPartners();
        });

        var page = {
            article: $('.newsEntryBody').length === 1,
            index: $('.wrapper > .index').length === 1
        };

        if (page.article) {
            waitForReady('article');
        } else if (page.index) {
            waitForReady('index');
        }
    }

    rnn.modules.register('dfp_advertising', {
        dfp_ad: dfp_ad,
        init: initDFPAds,
        check: checkAdsReturned,
        cleanAdString: cleanUp
    });

})(jQuery, window.rnn.modules.lotame);
